module.exports = "/_next/static/images/badge-google-play-store-light-764d3f1be69206f0930f64271b6a9268.svg";